require('./OKConsents.scss');

// @ vendor
const React = require('react');
const ReactDOM = require('react-dom');
const classnames = require('classnames');

const { PropTypes } = require('prop-types');

const { connect } = require('react-redux');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ actions
const okConsentsActions = require('../../actions/OKConsents');

// @ components
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { OKButton } = require('commonsComponents/OKButton');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKSwitch = require('../OKSwitch/OKSwitch');

// @ constants
const {
    OKCONSENTS_EMPTY_VALUE,
    OKCONSENTS_NEGATIVE_VALUE,
    OKCONSENTS_POSITIVE_VALUE,
    OKCONSENTS_CONSENTS_SWITCH,
    OKCONSENTS_CONSENTS_CHECKBOX
} = require('../../constants/constants');

class OKConsents extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            acceptAll: false,
        };

        this.handleToggleAcceptAll = this.handleToggleAcceptAll.bind(this);
        this.setNode = this.setNode.bind(this);
    }

    componentDidMount() {
        const { getConsents, placementId, getAllConsents } = this.props;
        getConsents(placementId, getAllConsents);
    }

    componentWillReceiveProps(nextProps) {
        const { immConsents } = nextProps;
        const consents = immConsents.filter((consents) => consents.getIn(['consentCell', 'displayType']) === OKCONSENTS_CONSENTS_SWITCH);
        const acceptAll = consents.every(consent => consent.get('status') === OKCONSENTS_POSITIVE_VALUE);
        this.setState({
            acceptAll,
        });
    }

    componentWillUnmount() {
        const { getAllConsents } = this.props;
        if (!getAllConsents) {
            this.props.reset();
        }
    }

    handleToggleAcceptAll() {
        const { handleAcceptAll, updateAllConsentsStatus } = this.props;
        const acceptAll = !this.state.acceptAll;
        const status = this.getConsentsStatusFromAcceptAllValue(acceptAll);

        this.setState({ acceptAll });

        updateAllConsentsStatus(status);

        if (handleAcceptAll) {
            handleAcceptAll(status);
        }
    }

    handleConsentChangeValue(consentId, value) {
        const { handleChangeValue, updateConsentStatus } = this.props;
        updateConsentStatus(consentId, value);

        if (handleChangeValue) {
            handleChangeValue(consentId, value);
        }
    }

    handleCheckboxChange(consentId, statusCheck) {
        const { updateConsentStatus } = this.props;
        const newStatus = !statusCheck;
        const newStatusConsent = newStatus ? OKCONSENTS_POSITIVE_VALUE : OKCONSENTS_NEGATIVE_VALUE;
        updateConsentStatus(consentId, newStatusConsent);
    }

    handleCheckboxChannel(consentId, channelIndex) {
        const { updateCheckboxChannel } = this.props;

        updateCheckboxChannel(consentId, channelIndex);
        //Future functions might be added to handleCheckboxChannel -- Erase comment on addition
    }

    getConsentsStatusFromAcceptAllValue(value) {
        let status = OKCONSENTS_EMPTY_VALUE;
        switch (value) {
            case true:
                status = OKCONSENTS_POSITIVE_VALUE;
                break;
            case false:
                status = OKCONSENTS_NEGATIVE_VALUE;
                break;
        }
        return status;
    }

    buildPlacementText() {
        const { immPlacementViewInfo } = this.props;
        const titleTranslationKey = immPlacementViewInfo.get('poEditorTitle');
        const bodyTranslationKey = immPlacementViewInfo.get('poEditorBody');
        let titleElement;
        let bodyElement;

        if (titleTranslationKey) {
            titleElement = (
                <h2 className="ok-consents__placement-view-info-title">
                    <FormattedText value={titleTranslationKey} />
                </h2>
            );
        }
        if (bodyTranslationKey) {
            bodyElement = (
                <p className="ok-consents__placement-view-info-body">
                    <FormattedText value={bodyTranslationKey} />
                </p>
            );
        }
        return (
            <section className="ok-consents__placement-view-info row">
                {titleElement}
                {bodyElement}
            </section>
        );
    }

    buildHeader() {
        const { immSelectAll, quickAcceptMode } = this.props;
        let header;

        if (immSelectAll.get('enabled')) {
            const blockTitle = <FormattedText value={immSelectAll.get('poEditor')} />;
            let checkbox;

            if (!quickAcceptMode) {
                checkbox = (
                    <OKCheckbox
                        idName="ok-consents_accept-all"
                        extraClass="ok-consents__block-title"
                        label={blockTitle}
                        onChange={this.handleToggleAcceptAll}
                        value={this.state.acceptAll}
                    />
                );
            }

            header = (
                <header className="row">
                    <h3 className="col-xs-12 ok-consents__header">
                        {checkbox}
                    </h3>
                </header>
            );
        }

        return header;
    }

    buildConsentTitle(immConsent, title) {
        const { showChannels } = this.props;
        const consentId = immConsent.getIn(['consentCell', 'id']);

        let titleElement;

        if (title) {
            titleElement = (
                <header className="ok-consents__header-title-consent">
                    <h3 className="ok-consents__question-title">
                        <FormattedText value={title} />
                    </h3>
                </header>
            );
        }

        return titleElement;
    }

    buildCheckboxsChannels(immConsent) {
        const immChannels = immConsent.get('channels');
        const consentId = immConsent.getIn(['consentCell', 'id']);
        const bodyTranslationKey = immConsent.getIn(['consentCell', 'poEditorBody']);

        const channelsList = immChannels.map((immChannel, channelIndex) => {
            const idChannel = immChannel.get('id');
            const textChannel = <FormattedText value={`${immChannel.get('poEditorChannel')}`} />;

            return (
                <div className="col-sm-4" key={idChannel}>
                    <OKCheckbox
                        idName={`${consentId}-${idChannel}`}
                        label={textChannel}
                        onChange={() => this.handleCheckboxChannel(consentId, channelIndex)}
                        value={immChannel.get('accepted')}
                    />
                </div>
            );
        });

        return (
            <div className="row ok-consents__channels">
                <FormattedText value={bodyTranslationKey} className="col-sm-12 ok-consents__channels-text" />
                {channelsList}
            </div>
        );
    }

    buildConsent(immConsent, index) {
        const { getAllConsents, showChannels } = this.props;
        const immConsentCell = immConsent.get('consentCell');
        const titleElement = this.buildConsentTitle(immConsent, immConsentCell.get('poEditorTitle'));

        const switchClassNames = classnames('col-xs-4 col-sm-2', {
            'ok-consents__switch-profile': getAllConsents,
            'ok-consents__switch': !getAllConsents
        });

        let checkboxsElement;
        let acceptanceTextConsent;

        if (showChannels && immConsent.get('channels').size > 0) {
            checkboxsElement = this.buildCheckboxsChannels(immConsent);
        } else {
            acceptanceTextConsent = <FormattedText value={immConsentCell.get('poEditorBody')} />;
        }

        return (
            <section className="row ok-consents__question" key={index}>
                <div className={switchClassNames}>
                    <OKSwitch className="pull-right"
                        negativeValue={OKCONSENTS_NEGATIVE_VALUE}
                        neutralValue={OKCONSENTS_EMPTY_VALUE}
                        positiveValue={OKCONSENTS_POSITIVE_VALUE}
                        onChange={(newValue) => this.handleConsentChangeValue(immConsentCell.get('id'), newValue)}
                        value={immConsent.get('status')}
                    />
                </div>
                <article className="col-xs-8 col-sm-10 ok-consents__question-text">
                    {titleElement}
                    {acceptanceTextConsent}
                </article>
                {checkboxsElement}
            </section>
        );
    }

    buildLegitimate() {
        const { immConsents } = this.props;
        const legitimateEnabled = immConsents.filter((consents) => consents.getIn(['consentCell', 'displayType']) === OKCONSENTS_CONSENTS_CHECKBOX);
        let accordions = [];
        if (legitimateEnabled) {
            accordions = legitimateEnabled.map((consents, index) => {
                const consentId = consents.getIn(['consentCell', 'id']);
                const statusConsent = consents.get('status');
                const statusCheck = statusConsent === OKCONSENTS_EMPTY_VALUE || statusConsent === OKCONSENTS_NEGATIVE_VALUE ? false : true;

                return (
                    <div className="row">
                        <Accordion isExpanded={false} customClassName="ok-consents__gdpr-accordion">
                            <AccordionHeader name="AccordionHeader" canBeExpanded={true} isRightArrowPosition={false} iconStyle="secondary">
                                <FormattedText value={consents.getIn(['consentCell', 'poEditorTitle'])} />
                            </AccordionHeader>
                            <AccordionBody name="AccordionBody">
                                <div className="">
                                    <OKCheckbox
                                        idName="consents-commercial-gdpr"
                                        extraClass="contracts-filter__group__checkbox-option"
                                        label={<FormattedText value={consents.getIn(['consentCell', 'poEditorBody'])} />}
                                        onChange={() => this.handleCheckboxChange(consentId, statusCheck)}
                                        value={statusCheck}
                                    />
                                </div>
                            </AccordionBody>
                        </Accordion>
                    </div>
                )
            });
        }
        return accordions;
    }

    setNode(ref) {
        this.nodeReference = ref;
    }

    render() {
        const { isFetching, immConsents, getAllConsents } = this.props;
        let okConsentsElement = null;

        if (isFetching) {
            okConsentsElement = <LoadingSection />;
        }

        if (immConsents.size > 0) {
            const placementTextElement = this.buildPlacementText();
            const headerElement = this.buildHeader();
            const consents = immConsents.filter((consents) => consents.getIn(['consentCell', 'displayType']) === OKCONSENTS_CONSENTS_SWITCH);
            const consentElements = consents.map((consent, index) => this.buildConsent(consent, index));
            const legitimateElement = this.buildLegitimate();

            okConsentsElement = (
                <section className="container-fluid ok-consents">
                    {!getAllConsents && placementTextElement}
                    {headerElement}
                    {consentElements}
                    {legitimateElement}
                </section>
            );
        }

        return okConsentsElement;
    }
}

OKConsents.defaultProps = {
    quickAcceptMode: false,
    showChannels: true,
}

OKConsents.propTypes = {
    getConsents: PropTypes.func.isRequired,
    handleAcceptAll: PropTypes.func,
    handleChangeValue: PropTypes.func,
    immConsents: PropTypes.object,
    immNeutral: PropTypes.object,
    immPlacementViewInfo: PropTypes.object.isRequired,
    immSelectAll: PropTypes.object.isRequired,
    isFetching: PropTypes.bool.isRequired,
    placementId: PropTypes.string.isRequired,
    quickAcceptMode: PropTypes.bool,
    reset: PropTypes.func.isRequired,
    showChannels: PropTypes.bool,
    updateAllConsentsStatus: PropTypes.func.isRequired,
    updateCheckboxChannel: PropTypes.func.isRequired,
    updateConsentStatus: PropTypes.func.isRequired,
};

module.exports.constructor = OKConsents;
module.exports.OKConsents = connect(
    state => ({
        immConsents: state.gdprConsents.get('consents'),
        immNeutral: state.gdprConsents.get('neutral'),
        immPlacementViewInfo: state.gdprConsents.get('placementViewInfo'),
        immSelectAll: state.gdprConsents.get('selectAll'),
        isFetching: state.gdprConsents.get('isFetching'),
    }),
    {
        getConsents: okConsentsActions.getConsents,
        reset: okConsentsActions.reset,
        updateAllConsentsStatus: okConsentsActions.updateAllConsentsStatus,
        updateCheckboxChannel: okConsentsActions.updateCheckboxChannel,
        updateConsentStatus: okConsentsActions.updateConsentStatus,
    }
)(OKConsents);
